import * as RouterEffects from './router.effect';
import * as MetaEffects from './meta.effect';
import * as ThemeEffects from './theme.effect';
import * as CookiesEffects from './cookies.effect';

export const appEffects = { ...RouterEffects, ...MetaEffects, ...ThemeEffects, ...CookiesEffects };
